import { Reducer, useReducer } from 'react';

export const useMergeState = <T>(initialState: T = {} as T) =>
  useReducer<Reducer<T, Partial<T>>>(
    (state, changes) => ({ ...state, ...changes }),
    initialState,
  );
